'use client';
import SvgIcon, {type SvgIconProps} from '@mui/material/SvgIcon';
import {styled} from '@mui/material/styles';
import {DEFAULT_ICON_SIZE} from '../AppIcon';

// Carries the catalog default itself: this is a MUI SvgIcon, not a FontAwesome glyph, so
// it cannot pick the size up from AppIcon and would otherwise fall back to MUI's 24px —
// half again the size of the icons beside it. A styled base rather than `sx` so a
// caller's own `sx` still wins.
const Root = styled(SvgIcon)({fontSize: DEFAULT_ICON_SIZE});

export function SvgWhatsappIcon(props: SvgIconProps) {
  return (
    <Root {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.9852 16.9453C18.696 17.764 17.5464 18.4412 16.6296 18.6393C16.002 18.7725 15.1836 18.8779 12.426 17.7352C9.3288 16.452 5.028 11.8812 5.028 8.83945C5.028 7.29099 5.9208 5.48789 7.482 5.48789C8.2332 5.48789 8.3988 5.50254 8.646 6.09551C8.9352 6.79412 9.64081 8.51535 9.7248 8.6918C10.0716 9.41561 9.37199 9.83934 8.86439 10.4695C8.70239 10.6592 8.51881 10.8643 8.72401 11.2172C8.92801 11.5629 9.6336 12.7129 10.6704 13.6359C12.0096 14.8291 13.0956 15.21 13.4844 15.3721C13.7736 15.4921 14.1192 15.4641 14.3304 15.2385C14.598 14.9492 14.9304 14.4692 15.2688 13.9963C15.5076 13.6578 15.8112 13.6155 16.1292 13.7355C16.344 13.81 19.074 15.0778 19.1892 15.2807C19.2744 15.4283 19.2744 16.1267 18.9852 16.9453ZM12.0024 0H11.9964C5.38079 0 0 5.38242 0 12C0 14.624 0.846008 17.0584 2.28481 19.033L0.789606 23.492L5.40121 22.0184C7.29841 23.2739 9.5628 24 12.0024 24C18.618 24 24 18.6176 24 12C24 5.38242 18.618 0 12.0024 0Z"
      />
    </Root>
  );
}
SvgWhatsappIcon.displayName = 'SvgWhatsappIcon';
